// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "vip-1uaXu";
export { _1 as "__esModule", _2 as "vip" }
export default { "__esModule": _1, "vip": _2 }
